export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13948.dc51cea6.jpg";